import { SVGProps } from 'react'

export const AddToListIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 144 144" {...props}>
    <defs>
      <path id="a" d="M0 0h144v144H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="b" fill="#fff">
        <use xlinkHref="#a" />
      </mask>
      <g fill-rule="nonzero" mask="url(#b)">
        <path
          fill="#9A6D48"
          d="M71.67 24.05A18 18 0 0054.29 38.8l-.04.23H42a9 9 0 00-9 9v63a9 9 0 009 9h60a9 9 0 009-9V47.78a9 9 0 00-9-8.74H89.75l-.04-.23A18 18 0 0072 24.04h-.33z"
        />
        <path
          fill="#BB8961"
          d="M57 94.54h.21a4.5 4.5 0 11-.42 0H57zm33 1.5a3 3 0 01.18 6H69a3 3 0 01-.18-6H90zm-33-19.5h.21a4.5 4.5 0 11-.42 0H57zm33 1.5a3 3 0 01.18 6H69a3 3 0 01-.18-6H90zm-33-19.5h.21a4.5 4.5 0 11-.42 0H57zm33 1.5a3 3 0 01.18 6H69a3 3 0 01-.18-6H90zm-18-24h.21a4.5 4.5 0 11-.42 0H72z"
        />
      </g>
      <g mask="url(#b)">
        <g transform="translate(82 90)">
          <circle cx="19" cy="19" r="19" fill="#D4A077" />
          <path
            fill="#755236"
            d="M19 9a2 2 0 012 2v6h6a2 2 0 110 4h-6v6a2 2 0 11-4 0v-6h-6a2 2 0 110-4h6v-6c0-1.1.9-2 2-2z"
          />
        </g>
      </g>
    </g>
  </svg>
)
